import React, { useState } from 'react';
import { theme } from '../theme';
import { Input, Button } from './ui';
import Icons from './Icons';

// ---------------------------------------------------------------------------
// Save Dialog
// ---------------------------------------------------------------------------
export default function SaveDialog({ sql, onSave, onClose, initialData, defaultName, defaultDescription }) {
  const [name, setName]               = useState(initialData?.name        || defaultName        || '');
  const [description, setDescription] = useState(initialData?.description || defaultDescription || '');
  const [category, setCategory]       = useState(initialData?.category    || 'General');

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
      onClick={onClose}>
      <div style={{ background: theme.surface, borderRadius: '12px', padding: '24px', width: '400px', maxWidth: '90vw', border: `1px solid ${theme.border}` }}
        onClick={(e) => e.stopPropagation()}>
        <h3 style={{ marginBottom: '16px', fontSize: '16px' }}>{initialData ? 'Update Query' : 'Save Query'}</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <Input label="Name" value={name} onChange={setName} placeholder="My Query" />
          <Input label="Description" value={description} onChange={setDescription} placeholder="Optional description" />
          <Input label="Category" value={category} onChange={setCategory} placeholder="General" />
          <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
            <Button variant="ghost" onClick={onClose}>Cancel</Button>
            <Button onClick={() => onSave({ name, description, category, sql })} disabled={!name} icon={<Icons.Save />}>Save</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
